import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';

const PaddedContainer = styled('div')({
    padding: '4px 0px 4px 16px'
});

export { PaddedContainer };
//# sourceMappingURL=PaddedContainer.mjs.map
